import { useEffect } from 'react';

const useNetworkRedirect = () => {
  const checkAndRedirect = async () => {
    if (!window.ethereum) return;

    try {
      const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
      const path = window.location.pathname;
      const chainId = parseInt(chainIdHex, 16);

      // ETH hálózaton tiltott oldalak
      const forbiddenOnEth = [
        '/swap',
        '/apeswap',
        '/babydogeswap',
        '/radioshack',
        '/radioliquidity',
        '/apeliquidity',
        '/bridge',
        '/liquidity',
        '/add',
        '/addapeliquidity',
        '/addradioliquidity',
        '/addbabydogeliquidity',
        '/removebabydoge',
        '/removeradio',
        '/removeape',
        '/remove',
        '/createbabydoge',
        '/createape',
        '/createradio',
        '/create',
        '/babydogefind',
        '/find',
        '/apefind',
        '/radiofind',
        '/limit-orders',
        '/mining',
        '/pools/all',
        '/be2mining/all',
      ]; 

      // BNB hálózaton tiltott oldalak
      const forbiddenOnBnb = [
        '/removeeth',
        '/ethswap',
        '/ethfind',
        '/ethliquidity',
        '/createeth',
        '/addethliquidity',
      ];

      const isForbidden =
        (chainId === 1 && forbiddenOnEth.some((forbiddenPath) => path.startsWith(forbiddenPath))) ||
        (chainId === 56 && forbiddenOnBnb.some((forbiddenPath) => path.startsWith(forbiddenPath)));

      if (isForbidden) {
        window.location.href = '/'; // redirect + reload
      }
    } catch (error) {
      console.error('Hálózat ellenőrzési hiba:', error);
    }
  };

  useEffect(() => {
    checkAndRedirect(); // oldal betöltésekor

    const handleChainChanged = () => {
      checkAndRedirect(); // hálózatváltáskor is
    };

    if (window.ethereum?.on) {
      window.ethereum.on('chainChanged', handleChainChanged);
    }

    return () => {
      if (window.ethereum?.removeListener) {
        window.ethereum.removeListener('chainChanged', handleChainChanged);
      }
    };
  }, []);
};

export default useNetworkRedirect;
